import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import defaultDateRange from 'src/utils/defaultDateRange';
import { IDateRange, IDateRangeFormatted } from 'src/models/general';
import { IClipping, ILabelArticle } from 'src/models/onlineMedia';

export interface IOfmComparison {
  isComparation: boolean;
  dateRange: IDateRange;
  dateRangeFormatted: IDateRangeFormatted;
  selectedClipping: Array<IClipping>;
  selectedLabel: Array<ILabelArticle>;
}

const initialDateRange = {
  startDate: defaultDateRange().startDate.subtract(7, 'days'),
  endDate: defaultDateRange().endDate.subtract(7, 'days')
};

const initialState: IOfmComparison = {
  isComparation: false,
  dateRange: {
    start: initialDateRange.startDate.toDate(),
    end: initialDateRange.endDate.toDate()
  },
  dateRangeFormatted: {
    start: initialDateRange.startDate.format('YYYY-MM-DD HH:mm:ss'),
    end: initialDateRange.endDate.format('YYYY-MM-DD HH:mm:ss')
  },
  selectedClipping: [],
  selectedLabel: []
};

export const ofmComparison = createSlice({
  name: 'ofmComparison',
  initialState,
  reducers: {
    reducerUpdateIsComparation: (
      state: IOfmComparison,
      action: PayloadAction<boolean>
    ) => {
      state.isComparation = action.payload;
    },
    reducerUpdateOfmComparisonDateRange: (
      state: IOfmComparison,
      action: PayloadAction<IDateRange>
    ) => {
      state.dateRange = action.payload;
      state.dateRangeFormatted = {
        start: moment(action.payload.start).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(action.payload.end).format('YYYY-MM-DD HH:mm:ss')
      };
    },
    reducerUpdateDataSelectedLabel: (
      state: IOfmComparison,
      action: PayloadAction<Array<ILabelArticle>>
    ) => {
      state.selectedLabel = action.payload;
    },
    reducerUpdateDataSelectedClipping: (
      state: IOfmComparison,
      action: PayloadAction<Array<IClipping>>
    ) => {
      state.selectedClipping = action.payload;
    }
  }
});

export const {
  reducerUpdateIsComparation,
  reducerUpdateOfmComparisonDateRange,
  reducerUpdateDataSelectedLabel,
  reducerUpdateDataSelectedClipping
} = ofmComparison.actions;

export default ofmComparison.reducer;
